import Vue from 'vue'

Vue.mixin({
  methods: {
    isMetaballValid(metaball) {
      return metaball && typeof metaball.radius === 'number'
    }
  }
})
